module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-448c34.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/glyphicons-halflings-regular.woff2
 ** module id = 511
 ** module chunks = 2
 **/